import React from 'react';

import PropTypes from 'prop-types';

import './ActionsCell.css';

import ApproveManualVoucherPaymentCell from './ApproveManualVoucherPaymentCell';

const ManualVoucherPaymentActionsCell = ({ id, approved, tableFilters }) => {
  if (approved) return null;

  return (
    <div className="actionsContainer">
      <ApproveManualVoucherPaymentCell id={id} tableFilters={tableFilters} />
    </div>
  );
};

ManualVoucherPaymentActionsCell.propTypes = {
  id: PropTypes.number.isRequired,
  approved: PropTypes.bool.isRequired,
  tableFilters: PropTypes.shape({}),
};

ManualVoucherPaymentActionsCell.defaultProps = {
  tableFilters: {},
};

export default ManualVoucherPaymentActionsCell;
